export default () => {
  const paralaxParent = document.querySelectorAll('.js-paralax-parent')
  paralaxParent.forEach(el => {
    const background = el.querySelector('.js-paralax-background')
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop
    const elOffset = el.offsetTop
    const bottom = (elOffset - window.innerHeight) - winScroll
    background.style.bottom= bottom + 'px';
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/onScrollEffects/ParalaxCta.js